import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEqual } from 'lodash';
import { Form, Card, Col, Row, Input, Button, Upload } from 'antd';
import CallbackModal from 'components/CallbackModal';
import ImageUploaderUtil from 'shared/utils/ImageUploaderUtil';
import {
  updloadImageState,
  regexPattern,
  submitModalState,
} from 'shared/constant';
import text from './EmployeeRegister.page.translation';
import CompanyModules from '../CompanyRegister/CompanyModules';
import EmployeeRolesView from '../CompanyRegister/EmployeeRolesView';
import SubmitModal from '../../components/SubmitModal/SubmitModal.component';
import './EmployeeRegister.style.less';
import organizationRoute from '../../route';

class FormEmployeeRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formValue: {},
      formEmployeeSubmit: {},
      fileList: [],
      isPicPhotoExceed: false,
      isPicPhotoIncorrectFormat: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.employeeId &&
      this.props.employeeDetails !== prevProps.employeeDetails &&
      this.props.employeeDetails.payload
    ) {
      const employeeData = this.props.employeeDetails.payload;
      const firstname = employeeData.firstname || '';
      const lastname = employeeData.lastname || '';
      const combinedName = `${firstname} ${lastname}`;

      const getEmail = get(employeeData, 'user_details.email', '');
      const getUrl = get(employeeData, 'user_details.profile_picture_url', '');
      const getRole = get(employeeData, 'user_details.user_role', []);
      const getPhone = get(employeeData, 'user_details.phone_mobile', '');

      let createFileList;

      if (getUrl) {
        createFileList = [
          {
            uid: '-1',
            name: getUrl,
            status: 'done',
            url: getUrl,
          },
        ];
        this._fileListSetState(createFileList);
      }

      this.props.form.setFieldsValue({
        employeeName: combinedName,
        employeePhone: getPhone,
        ktp_num: employeeData.ktp_num,
        emailInput: getEmail,
        availableEmployeeRoles: getRole,
        fileList: createFileList,
      });
    }

    if (!isEqual(this.props.initialUserRoles, prevProps.initialUserRoles)) {
      const checkedRoles = this.props.initialUserRoles.filter(x => x.checked);
      if (checkedRoles.length > 0) {
        this.props.form.setFieldsValue({
          availableEmployeeRoles: checkedRoles,
        });
      } else {
        this.props.form.setFieldsValue({
          availableEmployeeRoles: [],
        });
      }
    }
  }

  _fileListSetState = createFileList => {
    this.setState({
      fileList: createFileList,
    });
  };

  /**
   * check form validation and handle submit
   */
  _onValidate = (err, formValues) => {
    if (!err) {
      const { fileList, formValue } = this.state;

      const getFileListUid = get(formValues, 'fileList[0].uid', '');

      let employeePicture = '';
      if (fileList && fileList.length > 0 && getFileListUid !== '-1') {
        employeePicture = fileList[fileList.length - 1].originFileObj;
      }

      const formEmployeeSubmit = {
        employeeName: formValue.employeeName,
        ktp_num: formValue.ktp_num,
        email: formValue.emailInput,
        employeePhone: formValue.employeePhone,
        employeeRoles: formValues.availableEmployeeRoles,
        employeePicture,
      };

      this.props.onSubmit(formEmployeeSubmit);
    }
  };

  uploadValidator(rule, value, callback) {
    const fileStatus = get(value, 'file.status');
    if (fileStatus === updloadImageState.REMOVED) {
      callback(this.props.intl.formatMessage(text.formRequiredPhotoEmployee));
    }

    callback();
  }

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    const fieldsToValidate = ['availableEmployeeRoles'];

    validateFields(fieldsToValidate, this._onValidate);
  };

  onChangeUploadPicPhoto(info) {
    const lastFileList = info.fileList.slice(-1);

    if (lastFileList.length > 0) {
      const lastFile = lastFileList[0];
      const fileExt = ImageUploaderUtil.getFileExtByFileName(lastFile.name);
      const newFileName = ImageUploaderUtil.getNewFileName(fileExt);
      const newFileObj = ImageUploaderUtil.getNewFileObj(
        lastFile.originFileObj,
        newFileName,
        fileExt,
      );

      lastFileList[0].name = newFileName;
      lastFileList[0].originFileObj = newFileObj;
    }

    const fileState = ImageUploaderUtil.getUploadImageState(info.file);

    let newState = null;
    switch (fileState) {
      case updloadImageState.REMOVED:
        newState = {
          ...this.state,
          fileList: [],
          isPicPhotoExceed: false,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      case updloadImageState.FILE_SIZE_EXCEED:
        newState = {
          ...this.state,
          isPicPhotoExceed: true,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      case updloadImageState.INVALID_TYPE:
        newState = {
          ...this.state,
          isPicPhotoIncorrectFormat: true,
          isPicPhotoExceed: false,
        };
        break;
      case updloadImageState.VALID:
        newState = {
          ...this.state,
          fileList: lastFileList,
          isPicPhotoExceed: false,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      default:
        break;
    }

    if (newState) {
      this.setState(newState);
    }
  }

  getNewEmployeeRoles(prevState, role, checked) {
    const newEmployeeRoles = [...prevState.employeeRoles];
    for (let i = 0; i < newEmployeeRoles.length; i += 1) {
      if (newEmployeeRoles[i].id === role.id) {
        newEmployeeRoles[i].checked = checked;
      }
    }

    return newEmployeeRoles;
  }

  onSelectEmployeeRoles = (role, checked) => {
    const newEmployeeRoles = this.props.initialUserRoles.map(roles => ({
      ...roles,
    }));
    for (let i = 0; i < newEmployeeRoles.length; i += 1) {
      if (newEmployeeRoles[i].id === role.id) {
        newEmployeeRoles[i].checked = checked;
        break;
      }
    }

    this.props.updateInitialUserRoles(false, newEmployeeRoles);
  };
  onBeforeImageUpload = () => false;

  renderFormStep1 = () => {
    const { getFieldDecorator } = this.props.form;
    const {
      intl: { formatMessage },
      titleText,
      employeeId,
    } = this.props;
    const { formValue } = this.state;

    let disableInput = false;
    if (employeeId) {
      disableInput = true;
    }

    const picPhotoProps = {
      multiple: false,
      beforeUpload: this.onBeforeImageUpload,
      onChange: this.onChangeUploadPicPhoto.bind(this),
      fileList: this.state.fileList,
    };

    const defaultEmployeeName = get(formValue, 'employeeName', '');
    const defaultEmail = get(formValue, 'emailInput', '');
    const defaultKtp = get(formValue, 'ktp_num', '');
    const defaultPicture = get(formValue, 'fileList', '');
    const defaultPhone = get(formValue, 'employeePhone', '');

    return (
      <Card title={titleText}>
        <div className="card-content-wrapper left-card">
          <Row gutter={48}>
            <Col span={12}>
              <div className="field">
                <Form.Item
                  label={formatMessage(text.formLabelEmployeeName)}
                  required
                  colon={false}
                >
                  {getFieldDecorator('employeeName', {
                    initialValue: defaultEmployeeName,
                    rules: [
                      {
                        required: true,
                        message: formatMessage(text.formRequiredEmployeeName),
                      },
                    ],
                  })(
                    <Input
                      placeholder={formatMessage(
                        text.formPlaceholderEmployeeName,
                      )}
                      size="large"
                    />,
                  )}
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="field">
                <Form.Item
                  label={formatMessage(text.formLabelEmployeeEmail)}
                  required
                  colon={false}
                >
                  {getFieldDecorator('emailInput', {
                    initialValue: defaultEmail,
                    rules: [
                      {
                        type: 'email',
                        message: formatMessage(text.formInvalidEmployeeEmail),
                      },
                      {
                        required: true,
                        message: formatMessage(text.formRequiredEmployeeEmail),
                      },
                    ],
                  })(
                    <Input
                      placeholder={formatMessage(
                        text.formPlaceholderEmployeeEmail,
                      )}
                      disabled={disableInput}
                      size="large"
                    />,
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>

          <Row gutter={48}>
            <Col span={12}>
              <div className="field">
                <Form.Item
                  label={formatMessage(text.formLabelEmployeeKtp)}
                  required
                  colon={false}
                >
                  {getFieldDecorator('ktp_num', {
                    initialValue: defaultKtp,
                    rules: [
                      {
                        required: true,
                        message: formatMessage(text.formRequiredEmployeeKtp),
                      },
                      {
                        pattern: regexPattern.NUMBER,
                        message: formatMessage(
                          text.employeeFormInvalidNationalID,
                        ),
                      },
                    ],
                  })(
                    <Input
                      placeholder={formatMessage(
                        text.formPlaceholderEmployeeKtp,
                      )}
                      size="large"
                      style={{ width: '100%' }}
                    />,
                  )}
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="field photo-wrapper">
                <Form.Item
                  label={formatMessage(text.formLabelPhotoEmployee)}
                  colon={false}
                >
                  {getFieldDecorator('fileList', {
                    initialValue: defaultPicture,
                    validateFirst: true,
                    rules: [
                      {
                        required: true,
                        message: formatMessage(text.formRequiredPhotoEmployee),
                      },
                      {
                        validator: this.uploadValidator.bind(this),
                      },
                    ],
                  })(
                    <Upload
                      name="logo"
                      accept=".jpeg,.jpg"
                      className="upload-wrapper"
                      {...picPhotoProps}
                    >
                      <Button>
                        {formatMessage(text.formBtnPhotoEmployee)}
                      </Button>
                    </Upload>,
                  )}
                </Form.Item>
                <div>Maksimal ukuran file 1MB, format dalam .JPEG</div>
                <div className="error">
                  {this.state.isPicPhotoExceed
                    ? 'Foto yang diunggah melebihi 1MB, Tolong unggah foto lain'
                    : null}
                  {this.state.isPicPhotoIncorrectFormat
                    ? 'Format Foto yang diunggah harus dalam .JPEG atau .PNG'
                    : null}
                </div>
              </div>
            </Col>
          </Row>

          <Row gutter={48}>
            <Col span={12}>
              <div>
                <Form.Item
                  label={formatMessage(text.formLabelEmployeePhone)}
                  required
                  colon={false}
                >
                  {getFieldDecorator('employeePhone', {
                    initialValue: defaultPhone,
                    rules: [
                      {
                        required: true,
                        message: formatMessage(text.formRequiredEmployeePhone),
                      },
                      {
                        pattern: regexPattern.PHONE,
                        message: formatMessage(text.employeeFormInvalidPhone),
                      },
                    ],
                  })(
                    <Input
                      placeholder={formatMessage(
                        text.formPlaceholderEmployeePhone,
                      )}
                      size="large"
                    />,
                  )}
                </Form.Item>
              </div>
            </Col>
            <Col span={12}></Col>
          </Row>
        </div>
      </Card>
    );
  };

  renderFormStep2 = () => {
    const {
      intl: { formatMessage },
      initialUserRoles,
    } = this.props;

    const { getFieldDecorator } = this.props.form;
    const defaultRoles = initialUserRoles.filter(x => x.checked);

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>Set Employee Roles</Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="page-column-container">
              <Form.Item
                label={formatMessage(text.formLabelAvailableEmployeeRoles)}
                required
                colon={false}
              >
                {getFieldDecorator('availableEmployeeRoles', {
                  initialValue: defaultRoles,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredEmployeeRoles),
                    },
                  ],
                })(
                  <CompanyModules
                    availableModules={initialUserRoles}
                    onSelectModule={this.onSelectEmployeeRoles}
                    colSpan={6}
                  />,
                )}
              </Form.Item>

              <EmployeeRolesView
                employeeRoles={initialUserRoles}
                placeholder={formatMessage(text.employeeFormWarnSelectRole)}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderFormStep3 = () => {
    const {
      getSubmitModalSteps,
      submitAddUserState,
      submitAddEmployeeState,
      employeeId,
      intl: { formatMessage },
    } = this.props;
    const submitModalSteps = getSubmitModalSteps();
    let title = '';
    let retryTitle = '';
    let remarksErrorTitle = '';
    let remarksErrorDescription = '';
    let remarksSuccessTitle = '';
    let remarksSuccessDescription = '';
    if (employeeId) {
      title = formatMessage(text.employeeFormUpdateSubmittingTitle);
      retryTitle = formatMessage(text.employeeFormUpdateRetryTitle);
      remarksErrorTitle = formatMessage(
        text.employeeFormUpdateRemarksErrorTitle,
      );
      remarksErrorDescription = formatMessage(
        text.employeeFormUpdateRemarksErrorDescription,
      );
      remarksSuccessTitle = formatMessage(
        text.employeeFormUpdateRemarksSuccessTitle,
      );
      remarksSuccessDescription = formatMessage(
        text.employeeFormUpdateRemarksSuccessDescription,
      );
    } else {
      title = formatMessage(text.employeeFormCreateSubmittingTitle);
      retryTitle = formatMessage(text.employeeFormCreateRetryTitle);
      remarksErrorTitle = formatMessage(
        text.employeeFormCreateRemarksErrorTitle,
      );
      remarksErrorDescription = formatMessage(
        text.employeeFormCreateRemarksErrorDescription,
      );
      remarksSuccessTitle = formatMessage(
        text.employeeFormCreateRemarksSuccessTitle,
      );
      remarksSuccessDescription = formatMessage(
        text.employeeFormCreateRemarksSuccessDescription,
      );
    }

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>{title}</Col>
        </Row>
        <SubmitModal
          steps={submitModalSteps}
          formatMessage={formatMessage}
          submitAddUserState={submitAddUserState}
          submitAddEmployeeState={submitAddEmployeeState}
          retryTitle={retryTitle}
          remarksErrorTitle={remarksErrorTitle}
          remarksErrorDescription={remarksErrorDescription}
          remarksSuccessTitle={remarksSuccessTitle}
          remarksSuccessDescription={remarksSuccessDescription}
          remarksSuccessSubDescription={formatMessage(
            text.employeeFormCreateRemarksSuccessSubDescription,
          )}
          remarksCreateAnother={formatMessage(
            text.employeeFormCreateRemarksCreateAnother,
          )}
          resetSubmitModal={this.resetSubmitModal}
          companyId={employeeId}
        />
      </div>
    );
  };

  resetSubmitModal = () => {
    const { resetSubmitModal, initialUserRoles } = this.props;
    const newState = {
      ...this.state,
      formValue: {},
      fileList: [],
    };
    this.setState(newState);

    const newEmployeeRoles = initialUserRoles.map(x => ({
      ...x,
      checked: false,
    }));

    resetSubmitModal([], newEmployeeRoles);
  };

  onClickCancel = () => {
    const { history } = this.props;
    history.goBack();
  };

  onClickBack = () => {
    const { updateCreateNewCompanyStep } = this.props;
    updateCreateNewCompanyStep(1);
  };

  onClickBackToEmployeeList = () => {
    const { history } = this.props;
    history.replace('/dashboard/organization/employee-list');
  };

  onClickBackToEmployeeDetail = () => {
    const { history, employeeId } = this.props;
    history.replace(`/dashboard/organization/employee-detail/${employeeId}`);
  };

  onClickNext = () => {
    const {
      form: { validateFields },
    } = this.props;

    const fieldsToValidate = [
      'employeeName',
      'emailInput',
      'ktp_num',
      'fileList',
      'employeePhone',
    ];

    validateFields(fieldsToValidate, this.onValidateEmployeeData);
  };

  onValidateEmployeeData = (err, formValues) => {
    const { updateCreateNewCompanyStep } = this.props;
    if (!err) {
      const newState = {
        ...this.state,
        formValue: formValues,
      };

      this.setState(newState);

      updateCreateNewCompanyStep(2);
    }
  };

  _renderSubmit = () => {
    const {
      intl: { formatMessage },
      form: { getFieldsValue },
      employeeId,
      createNewCompanyStep,
      submitAddUserState,
      submitAddEmployeeState,
      onCancelModal,
    } = this.props;

    let btnText = '';
    if (employeeId) {
      btnText = formatMessage(text.btnEdit);
    } else {
      btnText = formatMessage(text.btnRegister);
    }

    const displayCancelButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState !== submitModalState.SUCCESS;

    const dipslayBackToListButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState === submitModalState.SUCCESS &&
      !employeeId;

    const dipslayBackToDetailsButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState === submitModalState.SUCCESS &&
      employeeId;

    const enabledCancel =
      submitAddUserState === submitModalState.FAILED ||
      submitAddEmployeeState === submitModalState.FAILED;

    const formData = getFieldsValue([
      'employeeName',
      'emailInput',
      'ktp_num',
      'fileList',
      'employeePhone',
    ]);

    let disableNext = false;
    if (formData) {
      disableNext =
        !formData.employeeName ||
        !formData.emailInput ||
        !formData.ktp_num ||
        !formData.fileList ||
        !formData.employeePhone;
    }

    return (
      <div className="submit-container">
        {createNewCompanyStep === 1 && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickCancel}
          >
            Cancel
          </Button>
        )}
        {createNewCompanyStep === 2 && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBack}
          >
            Back
          </Button>
        )}
        {createNewCompanyStep === 1 && (
          <Button
            type="primary"
            block
            className="register-vendor-submit-btn"
            onClick={this.onClickNext}
            disabled={disableNext}
          >
            Next
          </Button>
        )}
        {createNewCompanyStep === 2 && (
          <Button
            type="primary"
            block
            className="register-vendor-submit-btn"
            htmlType="submit"
          >
            {btnText}
          </Button>
        )}
        {displayCancelButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            disabled={!enabledCancel}
            onClick={onCancelModal}
          >
            Cancel
          </Button>
        )}
        {dipslayBackToListButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBackToEmployeeList}
          >
            Back to Employee List
          </Button>
        )}
        {dipslayBackToDetailsButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBackToEmployeeDetail}
          >
            Back to Details
          </Button>
        )}
      </div>
    );
  };

  _handleSubmitFinishOk = () => {
    this.props.updateSubmitModalFinishOpen(false, [], []);
    const getIdEmployee = get(this.props, 'employeeId', '');
    if (getIdEmployee) {
      this.props.history.push(
        organizationRoute.EMPLOYEE_DETAIL.replace(':id', getIdEmployee),
      );
    } else {
      this.props.history.push(organizationRoute.EMPLOYEE_LIST);
    }
  };

  _renderSubmitFinishModal = () => {
    const {
      intl: { formatMessage },
      employeeId,
    } = this.props;

    const descText = employeeId
      ? formatMessage(text.updateEmployeeSuccessDescription)
      : formatMessage(text.createNewEmployeeSuccessDescription);

    return (
      <CallbackModal
        onClose={this._handleSubmitFinishOk}
        modalVisible={this.props.submitModalFinishOpen}
        type="success"
        description={descText}
      />
    );
  };

  _handleSubmitErrorOk = () => {
    this.props.updateSubmitModalErrorOpen(false);
  };

  _renderSubmitErrorModal = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    return (
      <CallbackModal
        onClose={this._handleSubmitErrorOk}
        modalVisible={this.props.submitModalErrorOpen}
        type="failed"
        description={formatMessage(text.updateEmployeeErrorDescription)}
      />
    );
  };

  render() {
    const { createNewCompanyStep } = this.props;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          {createNewCompanyStep === 1 && this.renderFormStep1()}
          {createNewCompanyStep === 2 && this.renderFormStep2()}
          {createNewCompanyStep === 3 && this.renderFormStep3()}
          {this._renderSubmit()}
          {this._renderSubmitFinishModal()}
          {this._renderSubmitErrorModal()}
        </Form>
      </div>
    );
  }
}

FormEmployeeRegister.propTypes = {
  form: PropTypes.object,
  formValue: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  titleText: PropTypes.string.isRequired,
  btnText: PropTypes.string,
  intl: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  me: PropTypes.object.isRequired,
  updateSubmitModalFinishOpen: PropTypes.func.isRequired,
  submitModalFinishOpen: PropTypes.bool.isRequired,
  submitModalErrorOpen: PropTypes.bool,
  history: PropTypes.object,
  updateSubmitModalErrorOpen: PropTypes.func,
  employeeId: PropTypes.string,
  match: PropTypes.object,
  createNewCompanyStep: PropTypes.number,
  submitAddUserState: PropTypes.string,
  submitAddEmployeeState: PropTypes.string,
  onCancelModal: PropTypes.func,
  updateCreateNewCompanyStep: PropTypes.func,
  employeeDetails: PropTypes.object,
  initialUserRoles: PropTypes.array,
  getSubmitModalSteps: PropTypes.func,
  updateInitialUserRoles: PropTypes.func,
  resetSubmitModal: PropTypes.func,
};

export default FormEmployeeRegister;
